
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.3 10.208c0-.65-.058-1.275-.167-1.875H10.5v3.55h4.933a4.227 4.227 0 01-1.841 2.759v2.308h2.975C18.3 15.35 19.3 13 19.3 10.208z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M10.5 19.167c2.475 0 4.55-.817 6.066-2.217l-2.975-2.308c-.816.55-1.858.883-3.091.883-2.384 0-4.409-1.608-5.134-3.775h-3.05v2.367c1.509 2.991 4.6 5.05 8.184 5.05z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M5.366 11.742A5.493 5.493 0 015.075 10c0-.608.108-1.192.291-1.742V5.892h-3.05A9.054 9.054 0 001.333 10c0 1.483.358 2.875.983 4.108l2.375-1.85.675-.516z","fill":"#FBBC05"}}),_c('path',{attrs:{"d":"M10.5 4.483c1.35 0 2.55.467 3.508 1.367l2.625-2.625C15.041 1.742 12.975.833 10.5.833c-3.584 0-6.675 2.059-8.184 5.059l3.05 2.366c.725-2.166 2.75-3.775 5.134-3.775z","fill":"#EA4335"}})])
          )
        }
      }
    